import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ContentService } from 'src/app/services/content/content.service';
import { ContentSection } from 'src/app/shared/layout/content-section';
import { BasketOverviewComponent } from '../basket-overview/basket-overview.component';
import { MenyBasketOverviewComponent } from '../meny-basket-overview/meny-basket-overview.component';

@Component({
  selector: 'app-basket-overview-wrapper',
  templateUrl: './basket-overview-wrapper.component.html',
  styleUrls: ['./basket-overview-wrapper.component.scss'],
  imports: [BasketOverviewComponent, MenyBasketOverviewComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BasketOverviewWrapperComponent extends ContentSection {
  isDagrofa: boolean;

  constructor() {
    const contentService = inject(ContentService);
    super(contentService, 'basketOverview', { noIndex: true });

    this.isDagrofa = this.contentService.isDagrofa;
  }
}
